import { useEffect, useState } from "react";
import { Loader2, BadgePercent, ExternalLink } from "lucide-react";
import { api, fileUrl } from "@/lib/api";

export default function Bonus() {
  const [items, setItems] = useState(null);

  useEffect(() => { api.get("/bookmakers").then((r) => setItems(r.data)); }, []);

  const provaOra = (b) => {
    api.post(`/bookmakers/${b.id}/click`).catch(() => {});
    window.open(b.link, "_blank", "noopener");
  };

  if (!items) return <div className="flex justify-center py-20"><Loader2 className="h-8 w-8 animate-spin text-green-500" /></div>;

  return (
    <div className="space-y-6">
      <header>
        <h1 className="flex items-center gap-2 font-display text-4xl font-black uppercase tracking-tight text-zinc-950">
          <BadgePercent className="h-8 w-8 text-green-500" /> I bonus di Il Mago Tony
        </h1>
        <p className="text-sm font-semibold text-zinc-500">I bookmaker consigliati da Tony. Gioca responsabilmente (18+).</p>
      </header>

      <div data-testid="bonus-disclaimer" className="rounded-2xl border border-amber-300 bg-amber-50 p-4 text-center text-sm font-semibold text-amber-800">
        ⚠️ Gioca responsabilmente · Riservato ai maggiorenni (18+) · Il gioco può causare dipendenza patologica.
      </div>

      {items.length === 0 ? (
        <div data-testid="bonus-empty" className="rounded-3xl border-2 border-dashed border-slate-300 bg-white p-10 text-center text-zinc-500">
          Nessun bonus pubblicato al momento. Torna presto!
        </div>
      ) : (
        <div className="grid gap-4 md:grid-cols-2" data-testid="bonus-list">
          {items.map((b) => (
            <div key={b.id} data-testid={`bookmaker-card-${b.id}`} className="flex flex-col gap-3 rounded-3xl border-2 border-zinc-950 bg-white p-5 shadow-[6px_6px_0_0_#09090b]">
              <div className="flex items-center gap-3">
                {b.logo_path ? (
                  <img src={fileUrl(b.logo_path)} alt="" className="h-14 w-14 rounded-xl object-contain" />
                ) : (
                  <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-zinc-950 font-display text-lg font-black text-green-400">
                    {b.text?.slice(0, 2).toUpperCase()}
                  </div>
                )}
                <div className="flex-1">
                  {b.is_top && <span className="mb-1 inline-flex items-center gap-1 rounded-full bg-yellow-400 px-2 py-0.5 text-[10px] font-black uppercase text-zinc-950">★ Consigliato da Tony</span>}
                  <p className="font-semibold text-zinc-900">{b.text}</p>
                </div>
              </div>
              <button data-testid={`prova-ora-${b.id}`} onClick={() => provaOra(b)}
                className="flex items-center justify-center gap-2 rounded-full bg-green-500 py-3 text-sm font-black uppercase tracking-wide text-zinc-950 transition-colors hover:bg-green-400">
                Prova ora <ExternalLink className="h-4 w-4" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
